import request from '../request'

export function getMaterialByCode(materialCode) {
  return request.get('/base/material/byCode', { params: { materialCode } })
}

export function listMaterial(query) {
  return request.post('/base/material/list', {
    currentPage: query.pageIndex,
    pageSize: query.pageSize,
    materialCode: query.materialCode,
    materialName: query.materialName,
    includeInventoryQty: query.includeInventoryQty
  })
}
